import { PostData } from '../types';
import { MediaType } from '../../../../../models/graphql';

export const wideManualFeedVideoA = (data: PostData) =>
  data.hasDirectPublishProfile === false &&
  data.feedType === 'feed/reel' &&
  data.media &&
  data.media.type === MediaType.VIDEO &&
  data.media.width > data.media.height &&
  data.media.width / data.media.height > 1.91;
